module.exports = {"659006100":"博古其镇","659006101":"双丰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659006.json
// module id = 2937
// module chunks = 0